import { GetCulpritCustomerVehicleImagesQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritCustomerVehicleImages/getCulpritCustomerVehicleImagesQuery.type';
import { getCulpritCustomerVehicleImagesFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritCustomerVehicleImages/getCulpritCustomerVehicleImagesQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getCulpritCustomerVehicleImagesQueryOptions = (
  params: GetCulpritCustomerVehicleImagesQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['CulpritCustomerVehicleImages', params],
    queryFn: () => getCulpritCustomerVehicleImagesFunction(params),
    enabled: true,
  });
};
